/** Shared by web and iOS so every legal link uses the same documents. */
export const TERMS_URL = "https://convo.convergic.io/terms.html";
export const PRIVACY_URL = "https://convo.convergic.io/privacy.html";

// Bump when the Terms change. The corresponding documents are archived in docs/legal.
export const TERMS_VERSION = 1;

export function hasCurrentTerms(state: {
  termsAcceptedAt: Date | null;
  termsVersion: number | null;
}): boolean {
  return state.termsAcceptedAt != null && state.termsVersion === TERMS_VERSION;
}

export function isPlaceholderLegalUrl(url: string): boolean {
  return url.startsWith("PLACEHOLDER_");
}

/** Configuration check only; deployment verification checks HTTP reachability. */
export function hasLegalDocuments(): boolean {
  return [TERMS_URL, PRIVACY_URL].every(
    (url) => url.startsWith("https://") && !isPlaceholderLegalUrl(url),
  );
}
